import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    whishlist: [],
};
const whishlistSlice = createSlice({
    name: 'whishlist',
    initialState: initialState,
    reducers: {
        setWhishlist: (state, action) => {
            state.whishlist = action.payload;
        },
    },
});

export const { setWhishlist } = whishlistSlice.actions;
const whishlistReducer = whishlistSlice.reducer;
export default whishlistReducer;
